var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgShare = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.25 1.5C16.0074 1.5 15 2.50736 15 3.75C15 4.99264 16.0074 6 17.25 6C18.4926 6 19.5 4.99264 19.5 3.75C19.5 2.50736 18.4926 1.5 17.25 1.5ZM13.5 3.75C13.5 1.67893 15.1789 0 17.25 0C19.3211 0 21 1.67893 21 3.75C21 5.82107 19.3211 7.5 17.25 7.5C16.1801 7.5 15.2149 7.05198 14.5317 6.33333L8.76412 9.93809C8.91663 10.3464 9 10.7885 9 11.25C9 11.7115 8.91663 12.1536 8.76412 12.5619L14.5317 16.1667C15.2149 15.448 16.1801 15 17.25 15C19.3211 15 21 16.6789 21 18.75C21 20.8211 19.3211 22.5 17.25 22.5C15.1789 22.5 13.5 20.8211 13.5 18.75C13.5 18.2885 13.5834 17.8465 13.7359 17.4381L7.96824 13.8334C7.28504 14.552 6.31984 15 5.25 15C3.17893 15 1.5 13.3211 1.5 11.25C1.5 9.17893 3.17893 7.5 5.25 7.5C6.31984 7.5 7.28504 7.948 7.96824 8.66664L13.7359 5.06187C13.5834 4.65355 13.5 4.21151 13.5 3.75ZM5.25 9C4.00736 9 3 10.0074 3 11.25C3 12.4926 4.00736 13.5 5.25 13.5C6.49264 13.5 7.5 12.4926 7.5 11.25C7.5 10.0074 6.49264 9 5.25 9ZM15 18.75C15 17.5074 16.0074 16.5 17.25 16.5C18.4926 16.5 19.5 17.5074 19.5 18.75C19.5 19.9926 18.4926 21 17.25 21C16.0074 21 15 19.9926 15 18.75Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgShare);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/share.1cb0d391614dedb81f41b4a8305fcdf7.svg";